import { z } from 'zod'

const AppConfigEnvSchema = z.enum(['stage', 'development', 'prod', 'test'])

export const AppConfigSchema = z.object({
  requestTTL: z.string().regex(/^\d+$/).transform(Number),
  apiVersion: z.string().regex(/^\d+$/),
  developmentState: z.enum(['prod', 'stage', 'dev']),
  env: AppConfigEnvSchema,
  imageServiceCdn: z.string().url('Invalid Image service Url'),
  apiUrl: z.string().url('Invalid API url'),
  devVueAppUrl: z.string().url('Invalid app url').optional(),
  version: z.string(),
  rumApplicationId: z.string().min(3, 'Invalid Rum application Id'),
  rumClientToken: z.string().min(3, 'Invalid Rum client token'),
  userCentricsScriptId: z.string().min(3, 'Invalid onTrust scriptId'),
  googleClientId: z.string().min(3, 'Invalid Google Client ID'),
  googleMapsKey: z.string().min(3, 'Invalid Google Maps Api Key'),
  mParticleId: z.string().min(3, 'Invalid mParticle ID'),
  facebookAppId: z.string().min(3, 'Invalid Facebook App ID'),
  brazeId: z.string().min(3, 'Invalid Braze ID'),
  userCentricsGoogleConsentServiceId: z.string().min(3, 'Invalid UC Google consent Service ID'),
  kustomerApiKey: z.string().min(3, 'Invalid Kustomer API Key'),
  reCaptchaKey: z.string().min(3, 'Invalid Recaptcha API Key'),
  googleTagManagerId: z.string().min(3, 'Invalid google Tag Manager Id'),
  paymentHost: z.string(),
  appStoreUrl: z.string().min(3, 'Invalid app store url'),
  playMarketUrl: z.string().min(3, 'Invalid play market url'),
  applePayMerchantId: z.string(),
  googleMerchantId: z.string(),
  processOutKey: z.string(),
  kaspiClientId: z.string(),
  kaspiPartnerId: z.string(),
  kaspiOauthUrl: z.string(),
  kaspiOpayUrl: z.string(),
  incogniaSdkKey: z.string(),
  incogniaSdkUrl: z.string(),
  isIncogniaEnabled: z.boolean(),
  isDevtoolsEnabled: z.boolean(),
  helloSignClientId: z.string(),
  shouldCheckCountryCode: z.boolean(),
  shouldCheckLanguageCode: z.boolean(),
  useFallbackAppUrlValue: z.boolean(),
})

export type AppConfigDynamic = z.infer<typeof AppConfigSchema>
export type AppConfigEnv = z.infer<typeof AppConfigEnvSchema>

export interface AppConfigStatic {
  isBrowser: boolean
  isDevelopment: boolean
  name: string
  project: string
  appType: string
  platform: 'web' | 'github-actions'
}

export type AppConfig = AppConfigDynamic & AppConfigStatic
